import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from 'react-modal';

import * as actionsSujet from '../../../actions/sujet';
import * as actionsJourney1 from '../../../actions/journey1';
import * as _actionsBasket from '../../../actions/basket';
import * as _actionsSearch from '../../../actions/search';
import { RootState } from '../../../reducers';
import './Dashboard.scss';
import styles from '../../../components/CampaignRow/CampaignRow.module.scss';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import SpinnerV2 from '../../../components/SpinnerV2';
import CampaignRow from '../../../components/CampaignRow';
import { Button, EButtonType } from '@repo/apg-ui';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import Legende from '../../../components/Modal/Legende/Legende';
import { getParameterByName } from '../../../utils/toSearchParams';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';
import { ReactComponent as RemoveIcon } from '../../../assets/icons/bin.svg';
import { ReactComponent as LockIcon } from '../../../assets/icons/lock.svg';
import { ReactComponent as RightArrow } from '../../../assets/icons/arrow_right.svg';
import classNames from 'classnames';
import { format, isValid } from 'date-fns';
import { de } from 'date-fns/locale';
import EditBasketNameModal from '../../../components/Modal/EditBasketName/EditBasketNameModal';
import RemoveBasketModal from '../../../components/Modal/RemoveBasket/RemoveBasket';
import RemoveOfferModal from '../../../components/Modal/RemoveOffer/RemoveOffer';
import Tooltip from 'rc-tooltip';
import OffersTable from './OffersTable';
import bsStyles from '../../../styles/bs.module.scss';
import { useNavigate } from 'react-router';
import { ProductionHelpText } from './ProductionHelpText';
import { DashboardCards } from './DashboardCards';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  locales: any;
  location: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  journey3: boolean;
  actionsSujet: any;
  actionsJourney1: any;
  actionsBasket: typeof _actionsBasket;
  actionsSearch: typeof _actionsSearch;
  history: any;
  validationMessageConfig: any;
  keycloakReady: boolean;
}

export enum Campaigns {
  DEFAULT = 2,
  SHOW_WITHOUT_BTN = 10,
}

const Dashboard = (props: Props) => {
  const [currentlyVisible, setCurrentlyVisible] = React.useState(Campaigns.DEFAULT);
  const [currentlyVisibleNROffers, setCurrentlyVisibleNROffers] = React.useState(Campaigns.DEFAULT);
  const [currentlyVisibleOffers, setCurrentlyVisibleOffers] = React.useState(Campaigns.DEFAULT);
  const [loading, setLoading] = React.useState(false);
  const [campaigns, setCampaigns] = React.useState([]);
  const [nonReservingOffers, setNonReservingOffers] = React.useState([]);
  const [reservedOffers, setReservedOffers] = React.useState([]);
  const [reservedOffersLoading, setReservedOffersLoading] = React.useState(false);
  const [nonReservingOffersLoading, setNonReservingOffersLoading] = React.useState(false);
  const [baskets, setBaskets] = React.useState([]);
  const [basketsLoading, setBasketsLoading] = React.useState(false);
  const [basketsVisible, setBasketsVisible] = React.useState(Campaigns.DEFAULT);
  const [isBasketNameEditOpen, setIsBasketNameEditOpen] = React.useState(false);
  const [isBasketRemoveModalOpen, setIsBasketRemoveModalOpen] = React.useState(false);
  const [basketNameEditId, setBasketNameEditId] = React.useState('');
  const [basketNameEditName, setBasketNameEditName] = React.useState('');
  const [basketNameEditReference, setBasketNameEditReference] = React.useState('');
  const [basketUnlockInProgress, setBasketUnlockInProgress] = React.useState(false);

  const [offerRemoveBasketId, setOfferRemoveBasketId] = React.useState('');
  const [offerRemoveName, setOfferRemoveName] = React.useState('');
  const [offerRemoveCustomer, setOfferRemoveCustomer] = React.useState('');
  const [offerRemoveNumber, setOfferRemoveNumber] = React.useState('');
  const [isOfferRemoveModalOpen, setIsOfferRemoveModalOpen] = React.useState(false);
  const [offerRemovalType, setOfferRemovalType] = React.useState('reserved');

  const navigate = useNavigate();
  const intl = useIntl();

  useEffect(() => {
    if (props.keycloakReady) {
      fetchCampaigns();
      fetchBaskets();
      fetchNonReservingOffers();
      fetchReservedOffers();
    }
  }, []);

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //     if (this.props.keycloakReady && this.props.keycloakReady !== prevProps.keycloakReady) {
  //         this.fetchCampaigns();
  //         this.fetchBaskets();
  //         this.fetchNonReservingOffers();
  //         this.fetchReservedOffers();
  //     }
  // }

  const fetchCampaigns = (offset: number = 0, limit: number = 12) => {
    setLoading(true);

    props.actionsSujet
      .getCampaigns({
        owner: (window as any).keycloak.tokenParsed['gepard-nr'],
        offset,
        limit,
        category: 1,
      })
      .then((_campaigns) => {
        if (_campaigns) {
          const lengthState = campaigns.length;
          const length = _campaigns.length + lengthState;

          setCampaigns([...campaigns, ..._campaigns]);
          setCurrentlyVisible(length <= Campaigns.SHOW_WITHOUT_BTN ? length : lengthState || Campaigns.DEFAULT);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchNonReservingOffers = (offset: number = 0, limit: number = 12) => {
    setNonReservingOffersLoading(true);

    props.actionsSujet
      .getCampaigns({
        owner: (window as any).keycloak.tokenParsed['gepard-nr'],
        offset,
        limit,
        category: 2,
      })
      .then((res) => {
        if (res) {
          const lengthState = nonReservingOffers.length;
          const length = res.length + lengthState;
          setNonReservingOffers([...nonReservingOffers, ...res]);
          setCurrentlyVisibleNROffers(length <= Campaigns.SHOW_WITHOUT_BTN ? length : lengthState || Campaigns.DEFAULT);
        }
      })
      .finally(() => {
        setNonReservingOffersLoading(false);
      });
  };

  const fetchReservedOffers = (offset: number = 0, limit: number = 12) => {
    setReservedOffersLoading(true);

    props.actionsSujet
      .getCampaigns({
        owner: (window as any).keycloak.tokenParsed['gepard-nr'],
        offset,
        limit,
        category: 3,
      })
      .then((res) => {
        if (res) {
          const lengthState = reservedOffers.length;
          const length = res.length + lengthState;
          setReservedOffers([...reservedOffers, ...res]);
          setCurrentlyVisibleOffers(length <= Campaigns.SHOW_WITHOUT_BTN ? length : lengthState || Campaigns.DEFAULT);
        }
      })
      .finally(() => {
        setReservedOffersLoading(false);
      });
  };

  const fetchBaskets = (offset: number = 0, limit: number = 12, refresh: boolean = false) => {
    setBasketsLoading(true);

    props.actionsBasket
      .fetchBasketInfo(
        // @ts-expect-error we can't supply a basketId here, type is required.
        {
          offset,
          limit,
        },
        null,
        true,
      )
      .then((res) => {
        if (res) {
          const lengthState = baskets.length;
          const length = res.length + lengthState;
          const newBaskets = refresh ? res : [...baskets, ...res];
          setBaskets(newBaskets);
          setBasketsVisible(length <= Campaigns.SHOW_WITHOUT_BTN ? length : lengthState || Campaigns.DEFAULT);
        }
      })
      .finally(() => {
        setBasketsLoading(false);
      });
  };

  const renderModalContent = (modalContent) => {
    if (modalContent === 'legende') {
      return <Legende />;
    } else if (modalContent === 'basketEdit') {
      return (
        <EditBasketNameModal
          onClose={() => {
            setIsBasketNameEditOpen(false);
          }}
          onSuccess={updateBasketName}
          initName={basketNameEditName}
          basketId={basketNameEditId}
          basketreference={basketNameEditReference}
          updateBasketName={props.actionsBasket.postBasketData}
        />
      );
    } else if (modalContent === 'removeBasket') {
      return (
        <RemoveBasketModal
          basketId={basketNameEditId}
          basketreference={basketNameEditReference}
          initName={basketNameEditName}
          onClose={() => {
            setIsBasketRemoveModalOpen(false);
          }}
          onSuccess={() => {
            setIsBasketRemoveModalOpen(false);
          }}
          removeBasket={removeBasket}
        />
      );
    } else if (modalContent === 'removeOffer') {
      return (
        <RemoveOfferModal
          basketId={offerRemoveBasketId}
          name={offerRemoveName}
          customer={offerRemoveCustomer}
          offerId={offerRemoveNumber}
          onClose={() => {
            setIsOfferRemoveModalOpen(false);
          }}
          onSuccess={() => {
            setIsOfferRemoveModalOpen(false);
          }}
          removeBasket={offerRemovalType === 'reserved' ? removeCampaignReservedOffer : removeCampaignNROffer}
        />
      );
    }
  };

  const isAgency = () => {
    return props.userDataEC.userInfo ? props.userDataEC.userInfo.role === 4 : false;
  };

  const removeBasket = (basketId: string, basketreference: string) => {
    const newBaskets = baskets.filter(
      (basket) => basket.basket !== basketId && basket.basketreference !== basketreference,
    );
    setBaskets(newBaskets);
    setBasketsVisible(basketsVisible - 1);

    return props.actionsBasket.deleteBasket({
      basket: Number(basketId),
      basketreference: basketreference,
    });
  };

  const removeCampaignReservedOffer = (basketId: string) => {
    const newOffers = reservedOffers.filter((campaign) => campaign.basket.id !== basketId);
    setReservedOffers(newOffers);
    setCurrentlyVisibleOffers(currentlyVisibleOffers - 1);

    return props.actionsBasket.deleteBasket({
      basket: Number(basketId),
    });
  };

  const removeCampaignNROffer = (basketId: string) => {
    const newOffers = nonReservingOffers.filter((campaign) => campaign.basket.id !== basketId);
    setNonReservingOffers(newOffers);
    setCurrentlyVisibleNROffers(currentlyVisibleNROffers - 1);

    return props.actionsBasket.deleteBasket({
      basket: Number(basketId),
    });
  };

  const updateBasketName = (basketId: string, basketreference: string, name: string) => {
    const newBaskets = baskets.map((basket) => {
      if (basket.basket === basketId && basket.basketreference === basketreference) {
        basket.name = name;
      }
      return basket;
    });
    setBaskets(newBaskets);
  };

  const {
    history,
    userDataEC: { userInfo },
    location,
  } = props;

  const modalContent = getParameterByName('modalContent', location.search);

  const length = campaigns.length;

  return (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={intl.formatMessage({ id: 'ec.navigation.dashboard', defaultMessage: 'Dashboard' })}
        secondLevelLabel={intl.formatMessage({ id: 'ec.navigation.dashboard', defaultMessage: 'Dashboard' })}
      />
      <div
        className={classNames('container-fluid journey1 overflow-hidden p-0', {
          journey3: props.journey3,
        })}
      >
        {modalContent && (
          <Modal
            isOpen={Boolean(modalContent)}
            onRequestClose={() => {
              navigate({ search: '' });
              // this.setState({ isModalOpen: false, modalContent: null });
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal', bsStyles.bootstrap)}>{renderModalContent(modalContent)}</div>
          </Modal>
        )}

        {isBasketNameEditOpen && (
          <Modal
            isOpen={isBasketNameEditOpen}
            onRequestClose={() => {
              setIsBasketNameEditOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal small-modal', bsStyles.bootstrap)}>
              {renderModalContent('basketEdit')}
            </div>
          </Modal>
        )}

        {isBasketRemoveModalOpen && (
          <Modal
            isOpen={isBasketRemoveModalOpen}
            onRequestClose={() => {
              setIsBasketRemoveModalOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal small-modal', bsStyles.bootstrap)}>
              {renderModalContent('removeBasket')}
            </div>
          </Modal>
        )}
        {isOfferRemoveModalOpen && (
          <Modal
            isOpen={isOfferRemoveModalOpen}
            onRequestClose={() => {
              setIsOfferRemoveModalOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal small-modal', bsStyles.bootstrap)}>
              {renderModalContent('removeOffer')}
            </div>
          </Modal>
        )}

        <div className='pageContainer'>
          <DashboardCards userInfo={userInfo} isAgency={isAgency()} />
        </div>

        <ErrorContainer journeyType='dashboard' />

        <div className='pageContainerTwo py-0'>
          <ProductionHelpText />
        </div>

        <div className='pageContainerTwo'>
          <div className='row'>
            <div
              className={classNames('col-12 d-flex justify-content-between', {
                'flex-column': props.journey3,
              })}
            >
              <h4 className='font-weight-bold mb-3 mt-4'>
                <FormattedMessage id='as.sujet.gebuchteKampagnen' defaultMessage='Gebuchte Kampagnen' />
              </h4>
              {props.journey3 && (
                <p className='w-100'>
                  <FormattedMessage
                    id='as.sujet.journey03.explanationText'
                    defaultMessage='Hier können Sie Ihre gebuchten Kampagnen einfach und unkompliziert nochmals buchen. Wählen Sie dazu die gewünschte Kampagne mittels dem Kopiersymbol aus. Anschliessen werden Sie Schritt für Schritt durch die Buchung geführt.'
                  />
                </p>
              )}

              {!props.journey3 && (
                <Button className='mt-24' onClick={() => navigate({ search: `?modalContent=legende` })}>
                  <div className='legend d-flex'>
                    <p className='red-text'>
                      <FormattedMessage id='ec.confirmation.legend' defaultMessage='Legende' />
                    </p>
                  </div>
                </Button>
              )}
            </div>

            <div className='col-12 pb-4'>
              <div className='d-flex flex-column mt-48'>
                <div className={`d-flex table-header ${styles.productTitle}`}>
                  <div className={styles.productRowCampaignColumn}>
                    <div className='d-flex flex-column'>
                      <p className='small-text'>
                        <FormattedMessage id='ec.confirmation.table.details' defaultMessage='Details' />
                      </p>
                      <p className='font-weight-bold'>
                        <FormattedMessage id='ec.confirmation.table.campaign' defaultMessage='Kampagne' />
                      </p>
                    </div>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.sujet' defaultMessage='Sujet' />
                    </p>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.period' defaultMessage='Zeitraum' />
                    </p>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.advertisingForm' defaultMessage='Werbeform' />
                    </p>
                  </div>

                  <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                    <div className='d-flex flex-column'>
                      <p className='small-text'>
                        <FormattedMessage id='ec.confirmation.table.services' defaultMessage='Services' />
                      </p>
                      <p className='font-weight-bold'>
                        <FormattedMessage id='ec.confirmation.table.design' defaultMessage='Gestaltung' />
                      </p>
                    </div>
                  </div>

                  <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.print' defaultMessage='Druck' />
                    </p>
                  </div>

                  <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.spotUpload' defaultMessage='Spot upload' />
                    </p>
                  </div>

                  <div className={classNames(styles.productRowCampaignColumn)}>
                    <p className='font-weight-bold'>
                      <FormattedMessage
                        id='ec.confirmation.table.copyCampaign'
                        defaultMessage='Kampagne nochmals buchen'
                      />
                    </p>
                  </div>

                  <div className={classNames(styles.productRowCampaignColumn)} />
                </div>

                {campaigns &&
                  length > 0 &&
                  campaigns.map((campaign: any, index) => {
                    if (index < currentlyVisible) {
                      return (
                        <CampaignRow
                          key={`${campaign.number}`}
                          index={index}
                          product={campaign}
                          moreContent={campaign.number}
                        />
                      );
                    }

                    return null;
                  })}

                {!loading ? (
                  <>
                    {currentlyVisible !== length && length > Campaigns.SHOW_WITHOUT_BTN && (
                      <>
                        <div className='my-24 mx-auto'>
                          <Button
                            className='ms-24 add-to-cart'
                            buttonType={EButtonType.PillMedium}
                            onClick={() => {
                              fetchCampaigns(length, Campaigns.SHOW_WITHOUT_BTN);
                              setCurrentlyVisible(length);
                            }}
                          >
                            <FormattedMessage
                              id='ec.components.buttons.mehrLoden'
                              defaultMessage='Weitere Kampagnen anzeigen'
                            />
                          </Button>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <SpinnerV2 relative />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='pageContainerTwo'>
          <div className='row'>
            <div
              className={classNames('col-12 d-flex justify-content-between', {
                'flex-column': props.journey3,
              })}
            >
              <h4 className='font-weight-bold mb-3 mt-4'>
                <FormattedMessage id='as.sujet.baskets' defaultMessage='Warenkörbe' />
              </h4>
            </div>

            <div className='col-12 pb-4'>
              <div className='d-flex flex-column mt-48'>
                <div className={`d-flex table-header ${styles.productTitle}`}>
                  <div className={styles.productRowCampaignColumn}>
                    <div className='d-flex flex-column'>
                      <p className='font-weight-bold'>
                        <FormattedMessage
                          id='ec.confirmation.table.basket.lastaccess'
                          defaultMessage='Gespeichert am'
                        />
                      </p>
                    </div>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.basket.name' defaultMessage='Sujet/Warenkorbname' />
                    </p>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.basket.startat' defaultMessage='Zeitraum' />
                    </p>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.basket.formats' defaultMessage='Werbeform' />
                    </p>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage id='ec.confirmation.table.basket.totalCount' defaultMessage='Anzahl Flächen' />
                    </p>
                  </div>

                  <div className={styles.productRowCampaignColumn}>
                    <p className='font-weight-bold'>
                      <FormattedMessage
                        id='ec.confirmation.table.basket.totalBasket'
                        defaultMessage='Total Kosten brutto CHF'
                      />
                    </p>
                  </div>

                  <div className={classNames(styles.productRowCampaignColumn, styles.flexRow)} />
                </div>

                {baskets &&
                  baskets.length > 0 &&
                  baskets.map((basket: any, index) => {
                    if (index < basketsVisible && basket.state >= 0) {
                      return (
                        <div className={styles.productCampaignRow}>
                          <div className={styles.productRowCampaignColumn}>
                            {isValid(Date.parse(basket.lastaccess))
                              ? format(Date.parse(basket.lastaccess), 'dd-MM-yyyy', {
                                  locale: de,
                                })
                              : basket.lastaccess}
                          </div>
                          <div
                            className={classNames(
                              styles.productRowCampaignColumn,
                              'd-flex flex-row justify-content-start flex-nowrap',
                            )}
                          >
                            <p>{basket.name}</p>
                            {basket.state <= 0 && (
                              <Tooltip
                                overlayClassName={'rc-tooltip-bg-white'}
                                placement={'right'}
                                overlay={
                                  <b>
                                    <FormattedMessage
                                      id='ec.confirmation.renameBasket.legend'
                                      defaultMessage='Umbenennen'
                                    />
                                  </b>
                                }
                              >
                                <div
                                  className={styles.editButton}
                                  onClick={() => {
                                    setBasketNameEditId(basket.basket);
                                    setBasketNameEditReference(basket.basketreference);
                                    setBasketNameEditName(basket.name);
                                    setIsBasketNameEditOpen(true);
                                  }}
                                >
                                  <EditIcon />
                                </div>
                              </Tooltip>
                            )}
                          </div>
                          <div className={styles.productRowCampaignColumn}>
                            <FormattedMessage id='ec.campaignRow.Ab' defaultMessage='Ab' />{' '}
                            {isValid(Date.parse(basket.startdate))
                              ? format(Date.parse(basket.startdate), 'dd-MM-yyyy', {
                                  locale: de,
                                })
                              : basket.startdate}
                          </div>
                          <div className={styles.productRowCampaignColumn}>{basket.formats}</div>
                          <div className={styles.productRowCampaignColumn}>{basket.totalcount}</div>
                          <div className={styles.productRowCampaignColumn}>{basket.mediasum}</div>
                          <div className={classNames(styles.productRowCampaignColumn, styles.flexRow)}>
                            {basket.state > 0 &&
                              (basketUnlockInProgress ? (
                                <div
                                  style={{
                                    width: 30,
                                    height: 40,
                                    marginTop: 27,
                                    marginRight: 10,
                                    marginLeft: -20,
                                  }}
                                >
                                  <SpinnerV2 relative inText style={{ fill: '#B30200' }} />
                                </div>
                              ) : (
                                <Tooltip
                                  overlayClassName={'rc-tooltip-bg-white'}
                                  placement={'right'}
                                  overlay={
                                    <b>
                                      <FormattedMessage
                                        id='ec.confirmation.lockedBasket.legend'
                                        defaultMessage="Warenkorb gesperrt. {newline}Mittels 'Klick' auf das Schloss-Symbol können Sie den Warenkorb entsperren und weiter bearbeiten."
                                        values={{ newline: <br /> }}
                                      />
                                    </b>
                                  }
                                >
                                  <div
                                    onClick={() => {
                                      setBasketUnlockInProgress(true);

                                      props.actionsBasket
                                        .unlockBasket({
                                          basket: basket.basket,
                                          basketreference: basket.basketreference,
                                        })
                                        .then((res) => {
                                          fetchBaskets(0, 12, true);
                                          setBasketUnlockInProgress(false);
                                        });
                                    }}
                                    className={styles.lockButton}
                                  >
                                    <LockIcon />
                                  </div>
                                </Tooltip>
                              ))}
                            {basket.state <= 0 && (
                              <Tooltip
                                overlayClassName={'rc-tooltip-bg-white'}
                                placement={'right'}
                                overlay={
                                  <b>
                                    <FormattedMessage
                                      id='ec.confirmation.removeBasket.legend'
                                      defaultMessage='Löschen'
                                    />
                                  </b>
                                }
                              >
                                <div
                                  onClick={() => {
                                    if (basket.state > 0) {
                                      return;
                                    }
                                    setBasketNameEditId(basket.basket);
                                    setBasketNameEditReference(basket.basketreference);
                                    setBasketNameEditName(basket.name);

                                    setIsBasketRemoveModalOpen(true);
                                  }}
                                  className={styles.removeButton}
                                >
                                  <RemoveIcon />
                                </div>
                              </Tooltip>
                            )}
                            {basket.state <= 0 && (
                              <Tooltip
                                overlayClassName={'rc-tooltip-bg-white'}
                                placement={'right'}
                                overlay={
                                  <b>
                                    <FormattedMessage
                                      id='ec.confirmation.openBasket.legend'
                                      defaultMessage='Bearbeiten'
                                    />
                                  </b>
                                }
                              >
                                <div
                                  onClick={() => {
                                    props.actionsBasket
                                      .getBasketContent({
                                        basket: basket.basket,
                                        basketreference: basket.basketreference,
                                      })
                                      .then(() => {
                                        props.actionsBasket
                                          .fetchBasketInfo({
                                            basket: basket.basket,
                                            basketreference: basket.basketreference,
                                          })
                                          .then(() => {
                                            navigate('/journey2/1');
                                            props.actionsSearch.clearLocations();
                                            props.actionsBasket.openBasket();
                                          });
                                      });
                                  }}
                                  className={styles.removeButton}
                                >
                                  <RightArrow />
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      );
                    }

                    return null;
                  })}

                {!basketsLoading ? (
                  <>
                    {basketsVisible !== baskets.length && baskets.length > Campaigns.SHOW_WITHOUT_BTN && (
                      <>
                        <div className='my-24 mx-auto'>
                          <Button
                            className='ml-4 add-to-cart'
                            buttonType={EButtonType.PillMedium}
                            onClick={() => {
                              fetchBaskets(baskets.length, Campaigns.SHOW_WITHOUT_BTN);
                              setBasketsVisible(baskets.length);
                            }}
                          >
                            <FormattedMessage
                              id='ec.components.buttons.moreBaskets'
                              defaultMessage='Weitere Warenkörbe anzeigen'
                            />
                          </Button>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <SpinnerV2 relative />
                )}
              </div>
            </div>
          </div>
        </div>

        {reservedOffers && reservedOffers.length > 0 && (
          <OffersTable
            data={reservedOffers}
            isLoading={reservedOffersLoading}
            header={<FormattedMessage id='as.sujet.reservedOffers' defaultMessage='Reserved Offers' />}
            history={history}
            journey3={props.journey3}
            currentlyVisible={currentlyVisibleOffers}
            onLoadMore={() => {
              fetchReservedOffers(reservedOffers.length, Campaigns.SHOW_WITHOUT_BTN);
              setCurrentlyVisibleOffers(reservedOffers.length);
            }}
            onDeleteClick={(basket, customer, offerNumber) => {
              setOfferRemoveBasketId(basket.id);
              setOfferRemoveName(basket.name);
              setOfferRemoveCustomer(customer);
              setOfferRemoveNumber(offerNumber);
              setOfferRemovalType('reserved');
              setIsOfferRemoveModalOpen(true);
            }}
          />
        )}

        {nonReservingOffers && nonReservingOffers.length > 0 && (
          <OffersTable
            data={nonReservingOffers}
            isLoading={nonReservingOffersLoading}
            header={<FormattedMessage id='as.sujet.nonReservingOffers' defaultMessage='Non-reserving Offers' />}
            history={history}
            journey3={props.journey3}
            currentlyVisible={currentlyVisibleNROffers}
            onLoadMore={() => {
              fetchNonReservingOffers(nonReservingOffers.length, Campaigns.SHOW_WITHOUT_BTN);
              setCurrentlyVisibleNROffers(nonReservingOffers.length);
            }}
            onDeleteClick={(basket, customer, offerNumber) => {
              setOfferRemoveBasketId(basket.id);
              setOfferRemoveName(basket.name);
              setOfferRemoveCustomer(customer);
              setOfferRemoveNumber(offerNumber);
              setOfferRemovalType('nonreserving');
              setIsOfferRemoveModalOpen(true);
            }}
          />
        )}
      </div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
    actionsJourney1: bindActionCreators(actionsJourney1 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
